import { zodResolver } from "@hookform/resolvers/zod";
import { Input } from "@workspace/web-ui/components/input";
import { Label } from "@workspace/web-ui/components/label";
import { PhoneInput } from "@workspace/web-ui/components/phone-input/index";
import { Textarea } from "@workspace/web-ui/components/textarea";
import { useForm } from "react-hook-form";
import { AppointmentFormData, appointmentFormSchema } from "../schemas";


interface FormPanelProps {
	onSubmit: (data: AppointmentFormData) => void;
	defaultValues?: Partial<AppointmentFormData>;
	className?: string;
}

export function FormPanel({
	onSubmit,
	defaultValues = {},
	className = "",
}: FormPanelProps) {
	const form = useForm<AppointmentFormData>({
		resolver: zodResolver(appointmentFormSchema),
		defaultValues,
	});

	const {
		register,
		handleSubmit,
		formState: { errors },
	} = form;

	return (
		<form
			onSubmit={handleSubmit(onSubmit)}
			id="appointment-form"
			className={`flex flex-col flex-1 w-full lg:px-7 lg:py-8 p-4 gap-5 ${className}`}
		>
			<div className="flex flex-col space-y-1.5">
				<Label htmlFor="name">Name</Label>
				<Input
					id="name"
					{...register("name")}
					aria-invalid={!!errors.name}
				/>
				{errors.name && (
					<span className="text-sm text-red-500">{errors.name.message}</span>
				)}
			</div>

			<div className="flex flex-col space-y-1.5">
				<Label htmlFor="email">Email address</Label>
				<Input
					id="email"
					type="email"
					{...register("email")}
					aria-invalid={!!errors.email}
				/>
				{errors.email && (
					<span className="text-sm text-red-500">{errors.email.message}</span>
				)}
			</div>

			<div className="flex flex-col space-y-1.5">
				<Label htmlFor="phone">Phone number</Label>
				<PhoneInput
					id="phone"
					{...register("phone")}
					aria-invalid={!!errors.phone}
				/>
				{errors.phone && (
					<span className="text-sm text-red-500">{errors.phone.message}</span>
				)}
			</div>

			<div className="flex flex-col space-y-1.5">
				<Label htmlFor="notes">
					Please share anything that will help prepare for our meeting.
				</Label>
				<Textarea
					id="notes"
					{...register("notes")}
					aria-invalid={!!errors.notes}
				/>
				{errors.notes && (
					<span className="text-sm text-red-500">{errors.notes.message}</span>
				)}
			</div>
		</form>
	);
}
